import { OvertimeRuleTypes, SchedulingRuleTypes, WagesRuleTypes } from '../laborRules/models/LaborRuleConfiguration';

// Jurisdictions here will always show the gov ref links in Scheduling guidance drawer
export const schedulingGovRefLinks: Map<string, string> = new Map([
  ['California', 'https://wagesla.lacity.org/sites/g/files/wph1941/files/2023-03/Fair%20Work%20Week%20Ordinance.pdf'],
  ['Pennsylvania', 'https://www.phila.gov/media/20200201213828/Fair-Workweek-Regulations-Final.pdf'],
  ['New York', 'https://www.nyc.gov/site/dca/businesses/fairworkweek-deductions-laws-employers.page#law'],
  ['Oregon', 'https://www.oregon.gov/boli/workers/pages/predictive-scheduling.aspx'],
  ['Washington', 'https://www.seattle.gov/laborstandards/ordinances/secure-scheduling'],
  ['Illinois', 'https://www.chicago.gov/city/en/depts/bacp/supp_info/fairworkweek.html'],
]);

export const localExceptionsJurisdicitions: Map<string, SchedulingRuleTypes[]> = new Map([
  [
    'California',
    [
      SchedulingRuleTypes.RightToRestRule,
      SchedulingRuleTypes.PredictabilityPayRule,
      SchedulingRuleTypes.SchedulePublishRule,
    ],
  ],
  ['Pennsylvania', Object.values(SchedulingRuleTypes)],
  ['New York', Object.values(SchedulingRuleTypes)],
  ['Oregon', [SchedulingRuleTypes.PredictabilityPayRule, SchedulingRuleTypes.SchedulePublishRule]],
  ['Washington', Object.values(SchedulingRuleTypes)],
  ['Illinois', Object.values(SchedulingRuleTypes)],
]);

export const stateExceptionsJurisdictions: Map<string, string[]> = new Map([
  ['California', [OvertimeRuleTypes.WorkDayTypeRule]],
]);

export const federalExceptionsJurisdictions: Map<string, string[]> = new Map([
  ['Alaska', [OvertimeRuleTypes.DailyOvertimeRule]],
  ['California', [OvertimeRuleTypes.DailyOvertimeRule, OvertimeRuleTypes.ConsecutiveDayOvertimeRule]],
  ['Colorado', [OvertimeRuleTypes.DailyOvertimeRule]],
  ['Kentucky', [OvertimeRuleTypes.ConsecutiveDayOvertimeRule]],
  ['Nevada', [OvertimeRuleTypes.DailyOvertimeRule]],
]);

export const federalExceptionsForTipsAndWages: Map<string, string[]> = new Map([
  ['Arizona', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Idaho', [WagesRuleTypes.TipMakeupPayRule]],
  ['Iowa', [WagesRuleTypes.TipMakeupPayRule]],
  ['New Hampshire', [WagesRuleTypes.TipMakeupPayRule]],
  ['North Dakota', [WagesRuleTypes.TipMakeupPayRule]],
  ['Pennsylvania', [WagesRuleTypes.TipMakeupPayRule]],
  ['Wisconsin', [WagesRuleTypes.TipMakeupPayRule]],
  ['American Samoa', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Nebraska', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Puerto Rico', [WagesRuleTypes.MinimumWageRule]],
  ['Virginia', [WagesRuleTypes.MinimumWageRule]],
  ['Arkansas', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Colorado', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Connecticut', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Delaware', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['District of Columbia', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Florida', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Hawaii', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Illinois', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Maine', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Maryland', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Massachusetts', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Michigan', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Missouri', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['New Jersey', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['New Mexico', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['New York', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Westchester', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Long Island', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Ohio', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Rhode Island', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['South Dakota', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Vermont', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Virgin Islands', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['West Virginia', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Alaska', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['California', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Guam', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Minnesota', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Montana', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Oregon', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Washington', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Flagstaff', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Tuscon', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Alameda', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Belmont', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Berkley', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Burlingame', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Cupertino', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Daly City', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['East Palo Alto', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['El Cerrito', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Emeryville', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Foster City', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Halfmoon Bay', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Hayward', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Los Altos', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Los Angeles', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Los Angeles County (unincorporated)', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Malibu', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Menlo Park', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Milpitas', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Mountain View', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Novato', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Oakland', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Palo Alto', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Pasedena', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Petaluma', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Redwood City', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Richmond', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Carlos', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Diego', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Francisco', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Jose', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Leandro', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Mateo', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['San Mateo County (unincorporated)', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Clara', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Monica', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Rosa', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Sonoma', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['South San Francisco', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Sunnyvale', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['West Hollywood', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Boulder (city)', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Boulder County', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Denver', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Edgewater', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Chicago', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Cook County', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Portland', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Rockland', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Howard County, MD', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Montgomery County', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ["Prince George's County", [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Minneapolis', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['St. Paul', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Nevada', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Albuquerque', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Bernalillo County', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Fe', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Fe County', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Portland Metro', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Non-urban counties', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Bellingham', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['City of Burien', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Everett', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['King County', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Renton', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['SeaTac', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Seattle', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Tacoma', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
  ['Tukwila', [WagesRuleTypes.MinimumWageRule, WagesRuleTypes.TipMakeupPayRule]],
]);

export const stateExceptionsForTipsAndWagesNotPermitted: Map<string, string[]> = new Map([
  ['Alaska', [WagesRuleTypes.TipMakeupPayRule]],
  ['California', [WagesRuleTypes.TipMakeupPayRule]],
  ['Alameda', [WagesRuleTypes.TipMakeupPayRule]],
  ['Belmont', [WagesRuleTypes.TipMakeupPayRule]],
  ['Berkley', [WagesRuleTypes.TipMakeupPayRule]],
  ['Burlingame', [WagesRuleTypes.TipMakeupPayRule]],
  ['Cupertino', [WagesRuleTypes.TipMakeupPayRule]],
  ['Daly City', [WagesRuleTypes.TipMakeupPayRule]],
  ['East Palo Alto', [WagesRuleTypes.TipMakeupPayRule]],
  ['El Cerrito', [WagesRuleTypes.TipMakeupPayRule]],
  ['Emeryville', [WagesRuleTypes.TipMakeupPayRule]],
  ['Foster City', [WagesRuleTypes.TipMakeupPayRule]],
  ['Halfmoon Bay', [WagesRuleTypes.TipMakeupPayRule]],
  ['Hayward', [WagesRuleTypes.TipMakeupPayRule]],
  ['Los Altos', [WagesRuleTypes.TipMakeupPayRule]],
  ['Los Angeles', [WagesRuleTypes.TipMakeupPayRule]],
  ['Malibu', [WagesRuleTypes.TipMakeupPayRule]],
  ['Menlo Park', [WagesRuleTypes.TipMakeupPayRule]],
  ['Milpitas', [WagesRuleTypes.TipMakeupPayRule]],
  ['Mountain View', [WagesRuleTypes.TipMakeupPayRule]],
  ['Novato', [WagesRuleTypes.TipMakeupPayRule]],
  ['Oakland', [WagesRuleTypes.TipMakeupPayRule]],
  ['Palo Alto', [WagesRuleTypes.TipMakeupPayRule]],
  ['Pasedena', [WagesRuleTypes.TipMakeupPayRule]],
  ['Petaluma', [WagesRuleTypes.TipMakeupPayRule]],
  ['Redwood City', [WagesRuleTypes.TipMakeupPayRule]],
  ['Richmond', [WagesRuleTypes.TipMakeupPayRule]],
  ['San Carlos', [WagesRuleTypes.TipMakeupPayRule]],
  ['San Diego', [WagesRuleTypes.TipMakeupPayRule]],
  ['San Francisco', [WagesRuleTypes.TipMakeupPayRule]],
  ['San Jose', [WagesRuleTypes.TipMakeupPayRule]],
  ['San Leandro', [WagesRuleTypes.TipMakeupPayRule]],
  ['San Mateo', [WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Clara', [WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Monica', [WagesRuleTypes.TipMakeupPayRule]],
  ['Santa Rosa', [WagesRuleTypes.TipMakeupPayRule]],
  ['Sonoma', [WagesRuleTypes.TipMakeupPayRule]],
  ['South San Franscisco', [WagesRuleTypes.TipMakeupPayRule]],
  ['Sunnyvale', [WagesRuleTypes.TipMakeupPayRule]],
  ['West Hollywood', [WagesRuleTypes.TipMakeupPayRule]],
  ['Minnesota', [WagesRuleTypes.TipMakeupPayRule]],
  ['Minneapolis', [WagesRuleTypes.TipMakeupPayRule]],
  ['St. Paul', [WagesRuleTypes.TipMakeupPayRule]],
  ['Montana', [WagesRuleTypes.TipMakeupPayRule]],
  ['Nevada', [WagesRuleTypes.TipMakeupPayRule]],
  ['New York', [WagesRuleTypes.TipMakeupPayRule]],
  ['Long Island', [WagesRuleTypes.TipMakeupPayRule]],
  ['Westchester', [WagesRuleTypes.TipMakeupPayRule]],
  ['Nassau', [WagesRuleTypes.TipMakeupPayRule]],
  ['Suffolk', [WagesRuleTypes.TipMakeupPayRule]],
  ['Westchester counties', [WagesRuleTypes.TipMakeupPayRule]],
  ['Oregon', [WagesRuleTypes.TipMakeupPayRule]],
  ['Portland Metro', [WagesRuleTypes.TipMakeupPayRule]],
  ['Non-urban counties', [WagesRuleTypes.TipMakeupPayRule]],
  ['Washington', [WagesRuleTypes.TipMakeupPayRule]],
  ['Bellingham', [WagesRuleTypes.TipMakeupPayRule]],
  ['City of Burien', [WagesRuleTypes.TipMakeupPayRule]],
  ['Everett', [WagesRuleTypes.TipMakeupPayRule]],
  ['King County', [WagesRuleTypes.TipMakeupPayRule]],
  ['Renton', [WagesRuleTypes.TipMakeupPayRule]],
  ['SeaTac', [WagesRuleTypes.TipMakeupPayRule]],
  ['Seattle', [WagesRuleTypes.TipMakeupPayRule]],
  ['Tacoma', [WagesRuleTypes.TipMakeupPayRule]],
  ['Tukwila', [WagesRuleTypes.TipMakeupPayRule]],
  ['Guam', [WagesRuleTypes.TipMakeupPayRule]],
]);

export const federalGuidanceStates: string[] = [
  'California',
  'Colorado',
  'Kentucky',
  'Minnesota',
  'Nevada',
  'Oregon',
  'Washington',
];

export const federalNoGuidanceStates: string[] = [
  'Connecticut',
  'Delaware',
  'Illinois',
  'Maine',
  'Maryland',
  'New Hampshire',
  'New York',
  'North Dakota',
  'Rhode Island',
  'Tennessee',
  'West Virginia',
];

export const customJurisdictions: Map<string, string> = new Map([
  ['Connecticut', `laborRules.rules.${WagesRuleTypes.TipMakeupPayRule}.ruleGuidance.custom.Connecticut`],
  ['Maryland', `laborRules.rules.${WagesRuleTypes.TipMakeupPayRule}.ruleGuidance.custom.Maryland`],
  ['Howard_County', `laborRules.rules.${WagesRuleTypes.TipMakeupPayRule}.ruleGuidance.custom.Howard`],
  ['Montgomery_County', `laborRules.rules.${WagesRuleTypes.TipMakeupPayRule}.ruleGuidance.custom.Montgomery`],
]);

export const customJurisdictionsForMinimumWage: Map<string, string> = new Map([
  ['Hayward', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Hayward`],
  ['Sonoma', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Sonoma`],
  ['Novato', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Novato`],
  ['Montgomery_County', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Montgomery_County`],
  ['Howard_County', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Howard_County`],
  ['St_Paul', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.St_Paul`],
  ['City_of_Burien', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.City_of_Burien`],
  ['King_County', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.King_County`],
  ['Renton', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Renton`],
  ['Tukwila', `laborRules.rules.${WagesRuleTypes.MinimumWageRule}.ruleGuidance.custom.Tukwila`],
]);
